<form [formGroup]="formGroup()">
  <div data-test="breeder-week-registration">
    <div class="flex--column">
      @for (field of visibleFields(); track field.name) {
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ field.labelKey | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [errorStateMatcher]="getErrorStateMatcher(field.name)"
            [step]="field.step"
            inputmode="decimal"
            [formControlName]="field.name"
            [placeholder]="field.labelKey | translate"
            [attr.data-test]="'breeder-week-registration__' + field.name"
            (input)="isMortalityField(field.name) ? onMortalityChange() : null"
          />
          @if (field.suffix) {
            <span matTextSuffix class="form-field-suffix">{{ field.suffix }}</span>
          }
          @if (hasError(field.name)) {
            <mat-error>{{ getValidationErrorMessage(field.name) }}</mat-error>
          }
        </mat-form-field>
      }
    </div>
  </div>
</form>
